import videojs from 'video.js'

const Plugin = videojs.getPlugin('plugin')

class BasePlugin extends Plugin {
  handleStateChanged(_e) {
  }

  get playerElement() {
    return this.player.el()
  }

  get tech() {
    return this.player.$('.vjs-tech')
  }

  get dom() {
    return videojs.dom
  }

  get hiddenClass() {
    return 'vjs-hidden'
  }
}

export default BasePlugin
